import type { WizardStepProps, BasicInfoSlice } from '../../../engine/types';
import {
  BasicInfoBannerField,
  BasicInfoNameField,
  BasicInfoPrizesField,
  BasicInfoDescriptionField,
} from '../../../blocks/basic-info';

/**
 * Configuration for the BasicInfoStep component.
 * Allows customization of which fields are shown and their constraints.
 */
export interface BasicInfoStepConfig {
  banner?: {
    show?: boolean;
    required?: boolean;
    recommendedSize?: string;
  };
  name?: {
    maxLength?: number;
    placeholder?: string;
  };
  prizes?: {
    show?: boolean;
    required?: boolean;
  };
  description?: {
    show?: boolean;
    required?: boolean;
  };
}

const DEFAULT_CONFIG: BasicInfoStepConfig = {
  banner: {
    show: true,
    required: false,
    recommendedSize: '1200x400px',
  },
  name: {
    maxLength: 100,
    placeholder: 'Ej: Torneo de Verano 2026',
  },
  prizes: {
    show: true,
    required: true,
  },
  description: {
    show: true,
    required: true,
  },
};

interface BasicInfoStepProps extends WizardStepProps<BasicInfoSlice> {
  config?: BasicInfoStepConfig;
}

export function BasicInfoStep({
  data,
  updateData,
  config: userConfig,
}: BasicInfoStepProps) {
  const config = { ...DEFAULT_CONFIG, ...userConfig };

  return (
    <div className="space-y-6">
      {config.banner?.show && (
        <BasicInfoBannerField
          bannerUrl={data?.bannerUrl ? data.bannerUrl : null}
          onBannerUrlChange={(url) => updateData({ bannerUrl: url })}
          recommendedSize={config.banner?.recommendedSize}
        />
      )}

      <BasicInfoNameField
        value={data?.name ?? ''}
        onChange={(name) => updateData({ name })}
        maxLength={config.name?.maxLength}
        placeholder={config.name?.placeholder}
      />

      {config.prizes?.show && (
        <BasicInfoPrizesField
          value={data?.prizes ?? ''}
          onChange={(prizes) => updateData({ prizes })}
          required={config.prizes.required}
        />
      )}

      {config.description?.show && (
        <BasicInfoDescriptionField
          value={data?.description ?? ''}
          onChange={(description) => updateData({ description })}
          required={config.description.required}
        />
      )}
    </div>
  );
}

export default BasicInfoStep;
